import { MAIN_PROFILE_ACTION, SURVEY_ACTION } from '../../../constants/actions'
import { mergeToNewObject } from '../../../util/object.helpers'

export const surveyProfile = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SURVEY_ACTION.CHANGE_STATE:
      return mergeToNewObject(state, { [payload.property]: payload.value })

    case SURVEY_ACTION.ON_SUBMIT_USER_SURVEY:
    case SURVEY_ACTION.ON_UPDATE_USER_SURVEY:
      const { surveyId, id, questionId, liked } = payload
      return mergeToNewObject(
        state,
        handleUserSurveyResponse(state, {
          surveyId,
          id,
          response: { [questionId]: { liked } }
        })
      )

    case SURVEY_ACTION.ON_SUBMIT_USER_SURVEY_SUCCESS:
    case SURVEY_ACTION.ON_UPDATE_USER_SURVEY_SUCCESS:
      return mergeToNewObject(state, handleUserSurveyResponse(state, payload))

    case MAIN_PROFILE_ACTION.ON_LOAD_MAIN_DATA_SUCCESS:
      return mergeToNewObject(state, { surveys: payload.surveys })

    case SURVEY_ACTION.ON_GET_USER_SURVEYS_SUCCESS:
      return mergeToNewObject(state, {
        userSurveys: payload
      })

    default:
      return state
  }
}

const INITIAL_STATE = {
  surveys: {},
  userSurveys: {}
}

const handleUserSurveyResponse = (state, { surveyId, id, response }) => {
  return {
    userSurveys: {
      ...state.userSurveys,
      [surveyId]: {
        ...state.userSurveys?.[surveyId],
        id,
        response: {
          ...state.userSurveys?.[surveyId]?.response,
          ...response
        }
      }
    }
  }
}
